import React, { useState, useEffect } from "react";
import { Progress } from "antd";
import SmallSpinner from "./SmallSpinner";

function TimedProgressBar({ time = 7000, load_after = true }) {
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    const duration = time;
    const interval = 100; // update every 100ms
    const totalIntervals = Math.ceil(duration / interval); // number of intervals to reach 100%
    const increment = 100 / totalIntervals; // calculate increment per interval

    const intervalId = setInterval(() => {
      setPercent((prevPercent) => {
        if (prevPercent >= 100) {
          clearInterval(intervalId);
          return 100;
        }
        return prevPercent + increment;
      });
    }, interval);

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, [time]);

  // Ensure no decimal in the percent value
  return percent.toFixed(0) >= 100 && load_after ? (
    <div className="flex flex-row justify-center items-center">
      <SmallSpinner loading={true}></SmallSpinner>
    </div>
  ) : (
    <Progress percent={Math.floor(percent)} size="small" />
  );
}

export default TimedProgressBar;
